import { render, staticRenderFns } from "./CompetitorsTotals.vue?vue&type=template&id=368635f4&"
import script from "./CompetitorsTotals.vue?vue&type=script&lang=ts&"
export * from "./CompetitorsTotals.vue?vue&type=script&lang=ts&"
import style0 from "./CompetitorsTotals.vue?vue&type=style&index=0&lang=scss&%40scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports